import { ApiReferenceReact } from '@scalar/api-reference-react';

/**
 * S10.T7 — Scalar try-it console mounted at /reference.
 *
 * Source of truth: apps/docs/public/openapi.public.json — integrator-facing
 * subset that excludes admin/operator routes. The full spec (with /admin/*)
 * lives at api.n4-payments.com.br/openapi.json for operator-internal use.
 * Refresh via `.github/workflows/regen-docs.yml` workflow on every prod
 * deploy of n4-api (S10.T10). Static fallback ensures the page renders
 * even when the API endpoint is down or CORS is misconfigured.
 *
 * Spec URL points at the bundled file (always served same-origin) but the
 * Scalar component allows the user to override via the URL bar; for the
 * try-it console (which makes real requests), the server URLs are baked
 * in via DocumentBuilder.addServer() on the backend.
 */
export function Reference() {
  return (
    <div className="reference-container">
      <ApiReferenceReact
        configuration={{
          url: '/openapi.public.json',
          theme: 'default',
          hideClientButton: false,
          hideTestRequestButton: false,
          showSidebar: false, // we have our own sidebar
          servers: [
            {
              url: 'https://api.n4-payments.com.br',
              description: 'Production',
            },
            {
              url: 'https://n4-api-production.up.railway.app',
              description: 'Production (Railway alias)',
            },
          ],
        }}
      />
    </div>
  );
}
